import React from "react";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import InputWrapper from "../../../layout/inputWrapper";
import ButtonWrapper from "../../../components/Button";
import { ownerOrApplicant, yesOrNo } from "../../../../TCPForms/data";


const SubStep1 = ({ formData, handleSubTabChange }) => {
    const { t } = useTranslation();
    const defaultValues = {
        ...formData
    }
    const { handleSubmit, control, reset } = useForm({defaultValues});
    const onSubmit = (data) => {
        handleSubTabChange(1, data)
    };
    return (
        <section className="groupContainer">
            <form onSubmit={handleSubmit(onSubmit)}>
                <div className="formContainer">
                    <div className="formHeaderContainer">
                        <h2 className="formHeading">
                            Basic Information
                        </h2>
                    </div>
                    <div className="formInputContainer">
                        <div className="columnWrapper">
                            <InputWrapper
                                control={control}
                                label={`${t("Are You the Owner or Applicant")}`}
                                defaultValue={formData?.ownerOrApplicant}
                                name={`ownerOrApplicant`}
                                type="radioButton"
                                data={ownerOrApplicant}
                                mandatory
                                validation={{
                                    required: {
                                        value: true,
                                        message: "Please select the gender",
                                    },
                                }}
                            />
                            <InputWrapper
                                control={control}
                                label={`${t("Is Your Property Part of Approved Layout")}`}
                                placeholder="approvedLayout"
                                defaultValue={formData?.approvedLayout}
                                name={`approvedLayout`}
                                type="radioButton"
                                data={yesOrNo}
                                mandatory
                                validation={{
                                    required: {
                                        value: true,
                                        message: "This field is required",
                                    },
                                }}
                            />
                        
                        </div>
                        <div className="columnWrapper">
                        <InputWrapper
                                control={control}
                                label={`${t("Is More than One Owner")}`}
                                defaultValue={formData?.morethanOneOwner}
                                name={`morethanOneOwner`}
                                type="radioButton"
                                data={yesOrNo}
                                mandatory
                                validation={{
                                    required: {
                                        value: true,
                                        message: "Please select the gender",
                                    },
                                }}
                            />
                            <InputWrapper
                                control={control}
                                label={`${t("Is More than One Property")}`}
                                defaultValue={formData?.morethanOneProperty}
                                name={`morethanOneProperty`}
                                type="radioButton"
                                data={yesOrNo}
                                mandatory
                                validation={{
                                    required: {
                                        value: true,
                                        message: "Please select the gender",
                                    },
                                }}
                            />
                        </div>
                        <br />
                    </div>
                </div>
                <div className="footerContainer">
                    <div className="buttonWrapper">
                        <ButtonWrapper
                            variant="contained"
                            color="error"
                            size="medium"
                            label="Prev"
                            sx={{ backgroundColor: '#CCC' }}
                            onClick={() => reset()}
                        />
                        <ButtonWrapper
                            variant="contained"
                            color="success"
                            size="medium"
                            label="Save"
                            type="submit"
                            sx={{ backgroundColor: '#157CB3' }}
                        />
                    </div>
                </div>
            </form>

        </section>
    );
};

export default SubStep1;
